var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"sidebar"},[_c('h3',{staticClass:"sidebar-title"},[_vm._v("Table of Contents")]),_vm._l((_vm.orderedLessonsWithoutIndex),function(l,i){return _c('router-link',{key:i,staticClass:"link",attrs:{"to":{
      name: 'lessons',
      params: { courseSlug: _vm.courseSlug, lessonSlug: l.lessonSlug },
    }}},[_vm._v(" "+_vm._s(_vm.orderedLessonsWithoutIndex.indexOf(l) + 1)+". "+_vm._s(l.lessonTitle)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }